import { useContext } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { apiPost, apiDelete } from 'api'
import AuthContext from 'context/auth-context'

const createUserSection = async (token, userId, sectionId) => {
  const url = `admin/users/${userId}/user_sections`
  const data = await apiPost({ url, token, objectName: 'user_section', params: { section_id: sectionId } })
  return data
}

const deleteUserSection = async (token, userId, userSectionId) => {
  const url = `admin/users/${userId}/user_sections/${userSectionId}`
  const data = await apiDelete({ url, token })
  return data
}

export const useCreateAdminUserSection = ({ userId, options } = {}) => {
  const token = useContext(AuthContext)
  const queryClient = useQueryClient()

  return useMutation(
    (sectionId) => createUserSection(token, userId, sectionId),
    {
      ...options,
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(['admin-user', userId])
        if (options?.onSuccess) options.onSuccess(data, variables)
      }
    }
  )
}

export const useDeleteAdminUserSection = ({ userId, options } = {}) => {
  const token = useContext(AuthContext)
  const queryClient = useQueryClient()

  return useMutation(
    (userSectionId) => deleteUserSection(token, userId, userSectionId),
    {
      ...options,
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(['admin-user', userId])
        if (options?.onSuccess) options.onSuccess(data, variables)
      }
    }
  )
}
